import React, { FC } from 'react'

const MinusIcon: FC = () => (
  <svg width="15" height="2" viewBox="0 0 15 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.0627 0C14.5804 0.000132242 15 0.447662 15 1C15 1.55234 14.5804 1.99987 14.0627 2H0.937285C0.419511 2 0 1.55242 0 1C0 0.44758 0.419511 0 0.937285 0H14.0627Z"
      fill="currentColor"
    />
  </svg>
)

export default MinusIcon
